import { useMutation } from '@tanstack/react-query';
import axiosClient from 'api/config/axios';
import { createErrorHandler } from 'api/config/axios.errors';

type Params = {
  tradeId: number;
  reason: string;
};

async function cancelEscrowTrade(params: Params) {
  const result = await axiosClient.mutate.post(`/api/v1/escrow/trades/by-trade/${params.tradeId}/cancel`, {
    reason: params.reason,
  });
  return result.data;
}

const mutationKey = ['escrow', 'cancel-trade'] as const;

export function useEscrowCancelTradeMutation() {
  return useMutation({
    mutationKey,
    mutationFn: cancelEscrowTrade,
    onError: createErrorHandler(
      "You can't cancel this trade now. If you still have the same issue, please contact us to resolve it",
    ),
  });
}
